module.exports = __webpack_public_path__ + "img/banner.3b2487d2.png";